export default{
    stations_typology: process.env.VUE_APP_CDIAC+'etl-cdiac/api/apiGeo/getListStationsByTypology/',
    station_info: process.env.VUE_APP_CDIAC+'etl-cdiac/api/apiGeo/getStation/',
    station_data: process.env.VUE_APP_CDIAC+'etl-cdiac/api/apiGeo/getLastDayDataByStation/',
    precipitation_A25: process.env.VUE_APP_CDIAC+'etl-cdiac/api/apiGeo/getAccumPpt',
    precipitation_A3: process.env.VUE_APP_CDIAC+'etl-cdiac/api/apiGeo/getA3ById/',
    broadcast_websocket: process.env.VUE_APP_CDIAC+'etl-cdiac/broadcast'
}